module.exports = __webpack_public_path__ + "img/customizable.637e8837.png";